const action = (state = {}, action) => ({ ...state, type: action.type });

export default action;